import type { YogaCheckId } from "@/lib/yoga-check-ids";

/**
 * The /yoga/ hub's "which of these yogas form in your chart?" check: its
 * analytics placement, slot floor and the rows it answers. The hub's call to
 * action promised "Find the yogas active in your kundali" and sent readers to
 * the chat; the check answers it on the page for the five yogas the hub's
 * guides explain, from one POST /kundali reply, with the guides' own verdict
 * (components/yoga/yoga-check.ts) and form props, unchanged.
 */

/** free_tool_started and calculator_used placement for the hub's check. */
export const YOGA_HUB_CHECK_PLACEMENT = "yoga_hub_check";

/**
 * The slot's floor, from the server HTML: the tallest measured state, which
 * every state fills (YogaHubCheckLazy has the numbers).
 */
export const YOGA_HUB_CHECK_RESERVE = "min-h-[700px] sm:min-h-[580px]";

/**
 * One yoga the hub checks: the engine's id, the guide's name and its URL.
 * The server section builds these from the guides' data, so the island never
 * imports that module.
 */
export interface YogaHubRow {
  id: YogaCheckId;
  name: string;
  href: string;
}
